/* eslint-disable class-methods-use-this */
/* eslint max-len: ["error", { "code": 120 }] */

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { FieldValidatorPlugin } from '../common/field-validator-plugin';

/**
 * A service to validate a certain value using Field Validator Plugin
 */
@Injectable({
  providedIn: 'root',
})
export class FormFieldService {
  /**
   * Validate form field
   * @param field(object) - {e.g {value: 1234}}
   * @param config(Array)
   * @param showAllError(boolean) - Flag to show all errors based on config(default: false)
   * @returns (Object) - List of errors (e.g { pattern : true})
   */
  static validateFormField(field, config, showAllError = false) {
    // If field is empty and not required, do not proceed with the validation
    const isRequired = (_.find(config, (c) => c.slug === 'required') || {});
    if (!field.value && _.isEmpty(isRequired)) {
      return null;
    }

    // validate field via form validator plugin
    const validate = (plugin) => {
      const valid = plugin.validate(field);

      if (!valid) {
        return (plugin.error || {});
      }
      return null;
    };

    // get plugin stack
    const pluginStack = config.map((conf) => FieldValidatorPlugin[_.camelCase(conf.slug)](conf.configContext));

    // execute validation
    let validationErrors = _.map(pluginStack, (plugin) => validate(plugin));
    validationErrors = _.filter(validationErrors, (err) => !_.isEmpty(err));
    validationErrors = showAllError ? validationErrors : _.take(validationErrors, 1);

    return _.chain(validationErrors)
      .keyBy((err) => _.camelCase(err.slug))
      .mapValues((err) => (_.isEmpty(err.config) ? true : err.config))
      .value();
  }
}
